import { render, staticRenderFns } from "./merchant_mng_page.vue?vue&type=template&id=a337ed60"
import script from "./merchant_mng_page.vue?vue&type=script&lang=js"
export * from "./merchant_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a337ed60')) {
      api.createRecord('a337ed60', component.options)
    } else {
      api.reload('a337ed60', component.options)
    }
    module.hot.accept("./merchant_mng_page.vue?vue&type=template&id=a337ed60", function () {
      api.rerender('a337ed60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/merchant/merchant_mng_page.vue"
export default component.exports